import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchStatsByType } from 'Store/stats/actions';
import { initializeList, updateStatsListSearch } from 'Store/lists/actions';
import { clearPageError } from 'Store/ui/actions';
import * as reducers from 'Store/reducers';

import Error from 'Containers/Error';
import ListPageHeader from 'Components/ListPageHeader';
import StatsList from 'Containers/StatsList/StatsList';
import ListGroup from 'Components/ListGroup';
import Loading from 'Components/Loading';
import ListSidebarBox from 'Components/ListSidebarBox/ListSidebarBox';
import ListFilterInput from 'Containers/ListFilterInput/ListFilterInput';
import StatsListFilters from 'Containers/StatsListFilters/StatsListFilters';
import { ROUTES } from 'Settings/route-strings';

class AdminStatsPage extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      requestedStats: false,
      loggedSchoolStats: false,
    };
  }

  componentDidMount() {
    this.fetchStats();
  }

  componentDidUpdate() {
    this.fetchStats();

    if (this.props.schoolStats && !this.state.loggedSchoolStats)
      this.setState({ loggedSchoolStats: true }, () =>
        console.log(JSON.stringify(this.props.schoolStats, null, 2))
      );
  }

  componentWillUnmount() {
    this.props.clearPageError(ROUTES.ADMIN_STATS);
  }

  fetchStats() {
    if (!this.state.requestedStats) {
      this.setState({ requestedStats: true }, () => {
        const { statsType, listType } = this.props;
        this.props.initializeList(listType, listType);
        this.props.fetchStatsByType(statsType);
      });
    }
  }

  render() {
    const {
      activeUser,
      isFetchingStats,
      pageError,
      list,
      listType,
    } = this.props;
    if (pageError) return <Error type="apiLoadError" code="500" />;
    if (!activeUser || !list) return <Loading />;

    return (
      <main className="Page__content">
        <ListPageHeader
          pageTitle="Tinybop Admin Stats"
          handleTabClick={() => null}
          message={null}
          list={list}
          type={listType}
          isSticky={false}
        />
        <ListGroup
          groupType="stats"
          size="wide"
          allowXAxisScroll
          sidebar={
            <ListSidebarBox>
              <ListFilterInput
                listId={listType}
                updateFilterCallback={this.props.updateStatsListSearch}
                showNoteWithZeroResults
              />
              <StatsListFilters selected={list.activeFilter} />
            </ListSidebarBox>
          }
        >
          <StatsList
            type={listType}
            list={list}
            isLoading={isFetchingStats}
            allowXAxisScroll
          />
        </ListGroup>
      </main>
    );
  }
}

AdminStatsPage.propTypes = {
  activeUser: PropTypes.object,
  isFetchingStats: PropTypes.bool.isRequired,
  pageError: PropTypes.object,
  list: PropTypes.object,
  listType: PropTypes.oneOf(['educators_stats', 'schools_stats']),
  statsType: PropTypes.oneOf(['educator', 'schools']),
  schoolStats: PropTypes.object,
  initializeList: PropTypes.func.isRequired,
  fetchStatsByType: PropTypes.func.isRequired,
  clearPageError: PropTypes.func.isRequired,
  updateStatsListSearch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, { match: { params } }) => {
  const type = params.type || 'schools';
  return {
    statsType: type,
    listType: `${type}_stats`,
    activeUser: reducers.getActiveUser(state),
    pageError: reducers.getPageError(state, ROUTES.ADMIN_STATS),
    isFetchingStats: reducers.isFetchingStats(state, 'statsByType'),
    list: reducers.getStatsListByType(state, type),
    schoolStats:
      type === 'schools' ? reducers.getSchoolStatsBreakdown(state) : undefined,
  };
};

export default connect(mapStateToProps, {
  fetchStatsByType,
  clearPageError,
  initializeList,
  updateStatsListSearch,
})(AdminStatsPage);
